// src/components/SplashScreen.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";

// مسیر ثابت در public/ + کش‌شکنی
const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent.includes("ReactSnap");
const LOGO_URL = isReactSnap
  ? "/logo.svg" // در react-snap
  : `/logo.svg`; // در مرورگر واقعی

export default function SplashScreen({ onComplete, minDuration = 3200 }) {
  useEffect(() => {
    const timer = setTimeout(onComplete, minDuration);
    return () => clearTimeout(timer);
  }, [onComplete, minDuration]);

  const sparks = Array.from({ length: 15 }, (_, i) => ({
    id: i,
    size: Math.random() * 3 + 2,
    duration: Math.random() * 1.5 + 1,
    delay: Math.random() * 1.5,
    x: Math.random() * 80 + 10,
    y: Math.random() * 60 + 20,
  }));

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #1a1a1a 0%, #2d1b0b 50%, #1a0f05 100%)",
      }}
    >
      {/* پس‌زمینه */}
      <div className="absolute inset-0 opacity-80">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-900 via-yellow-800 to-orange-900" />
        <div className="absolute inset-0 bg-gradient-to-tl from-yellow-700 via-amber-800 to-orange-900 opacity-50" />
      </div>

      {/* جرقه‌ها */}
      <div className="absolute inset-0 pointer-events-none">
        {sparks.map((s) => (
          <motion.div
            key={s.id}
            className="absolute rounded-full"
            style={{
              width: s.size,
              height: s.size,
              background: "#fffbeb",
              boxShadow: "0 0 8px #fffbeb, 0 0 16px #fbbf24, 0 0 24px #f59e0b",
              left: `${s.x}%`,
              top: `${s.y}%`,
            }}
            animate={{
              y: [0, 60, 120],
              x: [0, (Math.random() - 0.5) * 30, (Math.random() - 0.5) * 60],
              opacity: [1, 0.8, 0],
              scale: [1, 1.3, 0.5],
            }}
            transition={{
              duration: s.duration,
              delay: s.delay,
              repeat: Infinity,
              ease: "easeOut",
            }}
          />
        ))}
      </div>

      {/* لوگو */}
      <motion.div
        className="relative"
        initial={{ y: -300, rotateX: 80, scale: 0.3, filter: "blur(8px)" }}
        animate={{ y: 0, rotateX: 0, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 1.8, type: "spring", stiffness: 80, damping: 18 }}
      >
        <motion.img
          src={LOGO_URL}
          alt="ESF Gold"
          className="h-36 sm:h-44 w-auto drop-shadow-2xl"
          style={{
            filter: "drop-shadow(0 0 20px #fbbf24) drop-shadow(0 0 40px #f59e0b)",
          }}
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          onError={(e) => {
            console.error("لوگو لود نشد:", LOGO_URL);
            e.target.src =
              "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Crect width='120' height='120' fill='%23fbbf24' rx='20'/%3E%3Ctext x='60' y='75' font-family='Arial' font-size='48' fill='%231a0f05' text-anchor='middle'%3EESF%3C/text%3E%3C/svg%3E";
          }}
        />

        {/* انعکاس */}
        <motion.div
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-48 h-20 opacity-30"
          style={{
            background: "linear-gradient(to bottom, transparent, #fbbf24)",
            filter: "blur(20px)",
            clipPath: "ellipse(50% 40% at 50% 100%)",
          }}
          animate={{ scaleY: [0.8, 1, 0.8], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.div>

      {/* لودر */}
      <motion.div
        className="absolute bottom-16 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent rounded-full overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <motion.div
          className="absolute inset-y-0 left-0 w-8 bg-white"
          style={{
            filter: "blur(8px)",
            boxShadow: "0 0 12px #fff, 0 0 20px #fbbf24",
          }}
          animate={{ x: ["-100%", "400%"] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
        />
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 text-xs text-amber-200 tracking-widest"
      >
        ESF GOLD • نسخه {new Date().getFullYear()}
      </motion.p>
    </motion.div>
  );
}